import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { DlgCitaprogramComponent } from './dlg-citaprogram/dlg-citaprogram.component';
import { DlgEditarCuentaComponent } from './dlg-editar-cuenta/dlg-editar-cuenta.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
// import { ReasignacionModalComponent } from './reasignacion-modal/reasignacion-modal.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';
import { BitacoraDialogComponent } from 'src/app/components/bitacora-dialog/bitacora-dialog.component';
import { TipoServicioService } from '../tipo-servicio.service';

@Component({
  selector: 'app-citas-programadas',
  templateUrl: './citas-programadas.component.html',
  styleUrls: ['./citas-programadas.component.scss']
})
export class CitasProgramadasComponent implements OnInit {
  private destroy$ = new Subject<void>();
  minDate = new Date();
  maxDate = new Date();
  agentes = [{
    idagente: 0,
    nombre: 'Todos'
  }];
  agentesFiltrados: any[] = [];
  searchTecnico = '';
  estados = [{
    id: 1,
    name: 'Pendiente de asignar'
  }, {
    id: 2,
    name: 'Asignada'
  },
  {
    id: 3,
    name: 'Técnico en camino'
  }, {
    id: 4,
    name: 'Técnico en sitio'
  },
  {
    id: 5,
    name: 'Finalizado'
  }, {
    id: 6,
    name: 'Devuelta'
  },
  {
    id: 7,
    name: 'Cancelar'
  }, {
    id: 8,
    name: 'Cancelar por reagendamiento'
  },
  {
    id: 9,
    name: 'Cancelar por servicio correcto'
  }, {
    id: 10,
    name: 'Cita Vencida'
  },   {
    id: 11,
    name: 'Cita Vencida sin asignar'
  }, {
    id: 12,
    name: 'Cancelada automatica Liberate'
  }, {
    id: 13,
    name: 'Finalizado automatico Liberate'
  }, {
    id: 14,
    name: 'Suspendida Liberate'
  }];

  tiempos = [
    {
      id: 0,
      name: 'Todos'
    },
    {
      id: 'AM',
      name: 'AM'
    },
    {
      id: 'PM',
      name: 'PM'
    }
  ];

  provincias: any[] = [];

  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    PRIORIDAD: new FormControl(0),
    CONTRATA_TECNICO: new FormControl([]),
    AGENTE: new FormControl([]),
    ESTADO: new FormControl(''),
    TIEMPO: new FormControl(0),
    PROVINCIA: new FormControl(''),
    FECHAINI: new FormControl(new Date()),
    FECHAFIN: new FormControl(new Date()),
  });
  usuariosCant = 5;
  tableColumns: string[] = ['ID', 'FALLA', 'ESTADO', 'ADM_CONTRATA','CONTRATA', 'AGENTE', 'CUENTA', 'DIRECCION', 'LOCALIZACION', 'FECHAVISITA', 'AMPM', 'PRIORIDAD', 'TIPOLOGIA', 'SUBTIPOLOGIA', 'BOX', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent
  public actpage: number = 0;
  prioridades = [];
  contratasagente = [];
  @ViewChild('paginatortable') paginatortable: MatPaginator;
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private _tipoServicio: TipoServicioService
  ) { }

  async ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    await this.getTecnicosxContrata();
    this.getPrioridades();
    this.getProvincias();
    this.getContratasAgente();
    if (!user || (user.idrol != 1 && user.idrol != 23 && user.idrol != 24)) {
      this.router.navigate(['/home']);
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Citas';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // this.createAgente();
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
    this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Limpiar filtros de contrata y técnico al cambiar Instalaciones/Reparaciones
      this.grupoVal.get('CONTRATA_TECNICO').setValue([]);
      this.grupoVal.get('AGENTE').setValue([]);
      this.searchTecnico = '';
      this.getTecnicosxContrata().then(() => {
        this.getContratasAgente();
        this.get(0);
      });
    });
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  onContrataSeleccionada(event: any) {
    this.gateway.get('gettecnicosxcontrata', {
      IDPAIS: 5,
      IDDISTRIBUIDOR: this._tipoServicio.getValorActual().IDU,
      IDPADRE: this._tipoServicio.getValorActual().IDU,
      IDAREA: this._tipoServicio.getValorActual().IDAREA,
      provincias: null,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(event.value),
    }).then((result) => {
      let aux: any = result;
      if (aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      } else {
      }
    }).catch((e) => {
    });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this._tipoServicio.getValorActual().IDAREA }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.contratasagente = aux.rows;
    }
    ).catch((e) => {
    });
  }

  limpiarFiltros() {
    this.grupoVal.reset();
    this.grupoVal.controls.AGENTE.setValue([]);
    this.grupoVal.controls.CONTRATA_TECNICO.setValue([]);
    this.grupoVal.controls.TIEMPO.setValue(0);
    this.grupoVal.controls.PROVINCIA.setValue('');
    this.grupoVal.controls.FECHAINI.setValue(new Date());
    this.grupoVal.controls.FECHAFIN.setValue(new Date());
    this.get(0);
  }

  /** Devuelve el valor de CONTRATA_TECNICO o null si está vacío */
  private getContrataValue(val?: any): any {
    const v = val !== undefined ? val : this.grupoVal.get('CONTRATA_TECNICO').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  /** Devuelve el valor de AGENTE o null si está vacío */
  private getAgenteValue(): any {
    const v = this.grupoVal.get('AGENTE').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  /** Filtra la lista de técnicos según texto de búsqueda */
  filtrarTecnicos() {
    const term = (this.searchTecnico || '').trim().toLowerCase();
    if (!term) {
      this.agentesFiltrados = this.agentes;
    } else {
      this.agentesFiltrados = this.agentes.filter(a =>
        a.nombre.toLowerCase().includes(term)
      );
    }
  }

  /** Limpia búsqueda al abrir/cerrar dropdown de técnicos */
  onTecnicoDropdownToggle(opened: boolean) {
    if (opened) {
      this.searchTecnico = '';
      this.filtrarTecnicos();
    }
  }

  public descargar() {
    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      // height: '300px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getcountcitasprogramadas', // deve devolver total:number
        nombreServicioRegistros: 'getcitasprogramadasdescarga', // deve devolver rows:[]
        params: {
          // NUM_PAGINA: page,
          // NUM_ELEMENTOS: this.pageSize,
          IDAGENTE: this.getAgenteValue(),
          PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          IDESTADO: this.grupoVal.controls.ESTADO.value || [],
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          FILTRO: this.FILTER,
          IDPAIS: this.idpais,
          IDDISTRIBUIDOR: this._tipoServicio.getValorActual().IDU,
          IDPADRE: this._tipoServicio.getValorActual().IDU,
          IDAREA: this._tipoServicio.getValorActual().IDAREA,
          IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
          IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
        }
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp.valid) {
        const filtros = resp.result;
      }
    });
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: this._tipoServicio.getValorActual().IDU,
        IDPADRE: this._tipoServicio.getValorActual().IDU,
        IDAREA: this._tipoServicio.getValorActual().IDAREA,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2,
        IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
      }).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.filtrarTecnicos();
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => {
        reject(e);
      });
    })
  }

  getPrioridades() {
    this.gateway.get('getprioridades', {}).then((result) => {
      let aux: any = result;
      this.prioridades = aux;
    }
    ).catch(function (e) {
    });
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result: any) => {
      this.provincias = result.rows || [];
    }).catch(function (e) {});
  }

  get(page) {
    this.spinner.show();
    this.gateway.get('getcitasprogramadas',
      {
        IDAGENTE: this.getAgenteValue(),
        PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
        TIEMPO: this.grupoVal.controls.TIEMPO.value,
        IDESTADO: this.grupoVal.controls.ESTADO.value || [],
        FECHAINI: this.grupoVal.controls.FECHAINI.value,
        FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
        NUM_PAGINA: page,
        FILTRO: this.FILTER,
        NUM_ELEMENTOS: this.pageSize,
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: this._tipoServicio.getValorActual().IDU,
        IDPADRE: this._tipoServicio.getValorActual().IDU,
        IDAREA: this._tipoServicio.getValorActual().IDAREA,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
        IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
        IDPROVINCIA: this.grupoVal.controls.PROVINCIA.value || null,
      }).then((result) => {

        let aux: any = result;
        this.dataSource = aux.rows;
        //this.resultsLength = 3//;result[1][0].TOTAL;

        this.gateway.get('getcountcitasprogramadas', {
          IDAGENTE: this.getAgenteValue(),
          PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          IDESTADO: this.grupoVal.controls.ESTADO.value || [],
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          NUM_PAGINA: page,
          FILTRO: this.FILTER,
          NUM_ELEMENTOS: this.pageSize,
          IDPAIS: this.idpais,
          IDDISTRIBUIDOR: this._tipoServicio.getValorActual().IDU,
          IDPADRE: this._tipoServicio.getValorActual().IDU,
          IDAREA: this._tipoServicio.getValorActual().IDAREA,
          IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
          IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
          IDPROVINCIA: this.grupoVal.controls.PROVINCIA.value || null,
        }).then((result: any) => {
          this.resultsLength = result.rows[0].total;
          this.spinner.hide();
        });

      }
      ).catch(function (e) {
      });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
    this.subscriptioncreate.unsubscribe();
    this.subscriptionpais.unsubscribe();
  }

  // createAgente() {
  //   const dialogRef = this.dialog.open(CreateAgenteComponent, {
  //     maxWidth: '130vw',
  //     width: '900px',
  //     minHeight: '50vh',
  //     data: { operacion: 'Crear', agente: { idpais: this.idpais } },
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     this.get(this.actpage);
  //   });
  // }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0)
  }

  edit(element: any) {
    // console.log('cita:', element)
    //element.idpais = this.idpais;
    const dialogRef = this.dialog.open(DlgCitaprogramComponent, {
      maxWidth: '90%',
      width:'auto',
      // minHeight: '20vh',
      data: { operacion: 'Editar', agente: element, IDAREA: this._tipoServicio.getValorActual().IDAREA },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  verBitacora(element: any): void {
    this.dialog.open(BitacoraDialogComponent, {
      width: '80%',
      panelClass: 'bitacora-dialog-panel',
      data: { cita: element }
    });
  }

  editarCuenta(element: any): void {
    const dialogRef = this.dialog.open(DlgEditarCuentaComponent, {
      width: '400px',
      data: { cita: element },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

}
